import { render, staticRenderFns } from "./pools.vue?vue&type=template&id=4b9254d2"
import script from "./pools.vue?vue&type=script&lang=js"
export * from "./pools.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports